/*
  Al Tauheed Textiles: genuine recent-purchase notifications.
  Data: #tt-rp-data (rendered from the Flow-maintained metafield; privacy-safe fields only).
  Behaviour: first after 10 s, visible 6 s, then 25-40 s pause; at most 4 per page view;
  rotates through the entries across pages in this session; x hides them for the session.
  Never covers the sticky Add to cart bar, chat/WhatsApp buttons, cookie banner or drawers;
  if there is not enough room it simply skips that turn.
*/
(function () {
  var FIRST_DELAY = 10000;
  var VISIBLE_FOR = 6000;
  var GAP_MIN = 25000;
  var GAP_MAX = 40000;
  var MAX_PER_PAGE = 4;
  var MAX_AGE_H = 72;
  var KEY_DISMISS = 'tt-rp-dismissed';
  var KEY_INDEX = 'tt-rp-index';
  var BLOCKERS = [
    '.tt-sticky-atc.is-visible',
    '#shopify-chat', '#ShopifyChat', 'inbox-online-store-chat', '.shopify-chat',
    '#shopify-pc__banner', '.shopify-pc__banner__dialog',
    '[class*="whatsapp" i]', '[id*="whatsapp" i]', 'a[href*="wa.me"]',
    '#preview-bar-iframe', '#PBarNextFrameWrapper'
  ];

  function store(method, key, value) {
    try { return method === 'get' ? sessionStorage.getItem(key) : sessionStorage.setItem(key, value); } catch (e) { return null; }
  }

  var dataEl = document.getElementById('tt-rp-data');
  if (!dataEl || store('get', KEY_DISMISS) === '1') return;

  var entries, strings;
  try {
    entries = JSON.parse(dataEl.textContent) || [];
    strings = JSON.parse((document.getElementById('tt-rp-strings') || {}).textContent || '{}');
  } catch (e) {
    return;
  }

  var now = Date.now();
  entries = entries.filter(function (e) {
    var t = Date.parse(e && e.t);
    return e && e.title && e.url && !isNaN(t) && now - t <= MAX_AGE_H * 3600000 && t <= now + 3600000;
  });
  if (!entries.length) return;

  /* Honest relative time from the purchase hour (stored rounded down to the hour) */
  function timeLabel(iso) {
    var hours = Math.floor((Date.now() - Date.parse(iso)) / 3600000);
    if (hours < 1) return 'Purchased within the last hour';
    if (hours === 1) return 'Purchased about an hour ago';
    if (hours < 24) return 'Purchased ' + hours + ' hours ago';
    var days = Math.floor(hours / 24);
    return days === 1 ? 'Purchased 1 day ago' : 'Purchased ' + days + ' days ago';
  }

  function whoLabel(e) {
    var s = strings;
    if (e.n && e.c) return e.n + ' ' + (s.from || 'from') + ' ' + e.c + ' ' + (s.purchased || 'purchased');
    if (e.n) return e.n + ' ' + (s.purchased || 'purchased');
    if (e.c) return (s.someone || 'Someone') + ' ' + (s['in'] || 'in') + ' ' + e.c + ' ' + (s.purchased || 'purchased');
    return (s.someone || 'Someone') + ' ' + (s.purchased || 'purchased');
  }

  /* ---------- DOM ---------- */
  var box = document.createElement('div');
  box.className = 'tt-rp';
  box.setAttribute('role', 'status');
  box.setAttribute('aria-live', 'polite');
  box.hidden = true;
  box.innerHTML =
    '<a class="tt-rp__media" tabindex="-1" aria-hidden="true"><img alt="" width="56" height="56" decoding="async"></a>' +
    '<div class="tt-rp__body">' +
      '<p class="tt-rp__who"></p>' +
      '<a class="tt-rp__product"></a>' +
      '<p class="tt-rp__time"></p>' +
    '</div>' +
    '<button type="button" class="tt-rp__close">' +
      '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
    '</button>';
  box.querySelector('.tt-rp__close').setAttribute('aria-label', strings.close || 'Close purchase notifications');
  document.body.appendChild(box);

  var media = box.querySelector('.tt-rp__media');
  var img = media.querySelector('img');
  var who = box.querySelector('.tt-rp__who');
  var product = box.querySelector('.tt-rp__product');
  var time = box.querySelector('.tt-rp__time');

  var shown = 0;
  var timer = null;
  var watch = null;
  var hovering = false;
  var index = parseInt(store('get', KEY_INDEX), 10);
  if (isNaN(index) || index < 0) index = 0;

  function busy() {
    var b = document.body;
    if (document.hidden) return true;
    if (b.classList.contains('overflow-hidden') || b.classList.contains('overflow-hidden-mobile') ||
        b.classList.contains('overflow-hidden-tablet') || b.classList.contains('overflow-hidden-desktop')) return true;
    if (document.querySelector('cart-drawer.active, cart-drawer.animate.active, .drawer.active, quick-add-modal[open], details[open] > .menu-drawer, predictive-search[open]')) return true;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && a.type !== 'radio' && a.type !== 'checkbox') return true;
    return false;
  }

  /* Only fixed/sticky controls (or children of one) can sit under the box */
  function isFloating(el) {
    for (var i = 0; el && el !== document.body && i < 6; i++, el = el.parentElement) {
      var pos = getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') return true;
    }
    return false;
  }

  /* Distance from the bottom needed to clear visible fixed controls that sit under the box */
  function bottomOffset(boxWidth, base) {
    var offset = base;
    var left = base;
    var right = left + boxWidth;
    BLOCKERS.forEach(function (sel) {
      var els;
      try { els = document.querySelectorAll(sel); } catch (e) { return; }
      Array.prototype.forEach.call(els, function (el) {
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var cs = getComputedStyle(el);
        if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) return;
        if (!isFloating(el)) return; /* ordinary page content (e.g. footer WhatsApp link) scrolls away */
        if (r.right < left || r.left > right) return;
        if (r.top >= window.innerHeight || r.bottom <= window.innerHeight * 0.5) return;
        offset = Math.max(offset, window.innerHeight - r.top + 12);
      });
    });
    return offset;
  }

  function place() {
    var base = window.innerWidth < 750 ? 12 : 16;
    var w = box.offsetWidth || Math.min(340, window.innerWidth - 2 * base);
    var h = box.offsetHeight || 80;
    var off = bottomOffset(w, base);
    box.style.bottom = off + 'px';
    /* not enough room above the other controls: skip rather than cover anything */
    return window.innerHeight - off - h >= window.innerHeight * 0.35;
  }

  function fill(e) {
    who.textContent = whoLabel(e);
    product.textContent = e.title;
    if (e.v) {
      var v = document.createElement('span');
      v.className = 'tt-rp__variant';
      v.textContent = ' · ' + e.v;
      product.appendChild(v);
    }
    product.href = e.url;
    media.href = e.url;
    time.textContent = timeLabel(e.t);
    if (e.img) {
      img.src = e.img;
      media.hidden = false;
    } else {
      img.removeAttribute('src');
      media.hidden = true;
    }
  }

  function hide(then) {
    clearInterval(watch);
    box.classList.remove('is-visible');
    setTimeout(function () {
      box.hidden = true;
      if (then) then();
    }, 320);
  }

  function schedule(delay) {
    clearTimeout(timer);
    if (shown >= MAX_PER_PAGE || store('get', KEY_DISMISS) === '1') return;
    timer = setTimeout(show, delay);
  }

  function show() {
    if (store('get', KEY_DISMISS) === '1') return;
    if (busy()) return schedule(8000);
    var e = entries[index % entries.length];
    fill(e);
    box.hidden = false;
    if (!place()) {
      box.hidden = true;
      return schedule(15000);
    }
    void box.offsetWidth; /* commit the start state so the fade/slide runs */
    box.classList.add('is-visible');
    shown++;
    index = (index + 1) % entries.length;
    store('set', KEY_INDEX, String(index));

    var until = Date.now() + VISIBLE_FOR;
    clearInterval(watch);
    watch = setInterval(function () {
      /* a drawer opened or a control appeared underneath: get out of the way */
      if (busy() || !place()) {
        hide(function () { schedule(GAP_MIN); });
        return;
      }
      if (!hovering && Date.now() >= until) {
        hide(function () { schedule(GAP_MIN + Math.random() * (GAP_MAX - GAP_MIN)); });
      }
    }, 250);
  }

  box.addEventListener('mouseenter', function () { hovering = true; });
  box.addEventListener('mouseleave', function () { hovering = false; });
  box.addEventListener('focusin', function () { hovering = true; });
  box.addEventListener('focusout', function () { hovering = false; });
  box.querySelector('.tt-rp__close').addEventListener('click', function () {
    store('set', KEY_DISMISS, '1');
    clearTimeout(timer);
    hide();
  });

  function start() { schedule(FIRST_DELAY); }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);

  window.TTRecentPurchases = {
    entries: entries,
    showNow: function () { clearTimeout(timer); show(); },
    timeLabel: timeLabel,
    whoLabel: whoLabel
  };
})();
